// extracted by mini-css-extract-plugin
export var orderDetails = "_tn-2";
export var orderImage = "_tn-1";
export var orderMeta = "_tn-3";
export var orderSummary = "_tn-0";
export var rightArrow = "_tn-4";